import { QuoteServiceVariableFieldError } from '../quoteservicecomputation';
import { IQuoteServiceVariableFieldErrorData } from '../quoteservicecomputation.types';

export const mockQuoteServiceVariableFieldErrorData: IQuoteServiceVariableFieldErrorData = {
  name: ['Ensure this field has no more than 64 characters.'],
  value: ['Ensure this field has no more than 64 characters.']
};

export const mockQuoteServiceVariableFieldError = new QuoteServiceVariableFieldError(
  mockQuoteServiceVariableFieldErrorData
);
